import { render, staticRenderFns } from "./DoughnutWithLabel.vue?vue&type=template&id=e51a20c2"
import script from "./DoughnutWithLabel.vue?vue&type=script&lang=ts"
export * from "./DoughnutWithLabel.vue?vue&type=script&lang=ts"
import style0 from "./DoughnutWithLabel.vue?vue&type=style&index=0&id=e51a20c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports